<template>
  <el-card style="height: 100%" shadow="hover">
    <div style="display: flex; justify-content: center;">
      <el-progress
        type="circle"
        :percentage="attendancePercentage"
        :color="perColor(attendancePercentage)"
      ></el-progress>
    </div>
    <el-divider></el-divider>
    <el-table
      v-loading="attendanceList == null"
      :height="windowHeight - 400"
      :data="attendanceList"
    >
      <el-table-column label="Date" width="120" prop="date"></el-table-column>
      <el-table-column label="Description" width="100" prop="name"></el-table-column>
      <el-table-column label="Record" min-width="220">
        <template slot-scope="scope">
            <span v-if="scope.row.attendance.length > 0">
                {{scope.row.attendance[0].attendance_type.name}}
            </span>
            <span v-else>
                N/A
            </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="Actions" min-width="100">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.attendance.length > 0 &&
                scope.row.attendance[0].active_dispute_record == null &&
                scope.row.attendance[0].dispute_records.length > 0 &&
                scope.row.attendance[0].dispute_records[0].is_redisputable"
            @click="showDispute(scope.row, viewOnly = true)"
            style="cursor: pointer;"
            disable-transitions
          >View</el-tag>
          <el-tag
            v-if="scope.row.attendance.length > 0 && scope.row.attendance[0].active_dispute_record != null"
            :type="disputeColor(scope.row.attendance[0].active_dispute_record)"
            @click="showDispute(scope.row)"
            style="cursor: pointer;"
            disable-transitions
          >{{disputeStatus(scope.row.attendance[0].active_dispute_record)}}</el-tag>
          <el-tag
            v-if="scope.row.attendance.length > 0 &&
                scope.row.attendance[0].active_dispute_record == null &&
                (scope.row.attendance[0].attendance_type.is_absent || scope.row.attendance[0].dispute_records.length > 0)"
            :type="disputeColor(scope.row.attendance[0].dispute_records[0])"
            @click="showDispute(scope.row)"
            style="cursor: pointer;"
            disable-transitions
          >{{disputeStatus(scope.row.attendance[0].dispute_records[0])}}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <nxs-dispute-sidebar
      ref="disputeModal"
      v-model="tempDispute"
      :finalize="finalize"
      :approve="approve"
      :creating="creating"
    />
  </el-card>
</template>


<script>
import {mapFields} from "vuex-map-fields";
import nxsDisputeSidebar from "../../shared/Dispute.vue";

export default {
    props: ["eventTypeId"],
    components: {nxsDisputeSidebar},
    data() {
        return {
            attendanceList: null,
            attendancePercentage: 0,
            tempDispute: null,
            finalize: false,
            approve: false,
            creating: false
        };
    },
    watch: {
        tempDispute(value) {
            if (value.o_id && this.attednanceList != null) {
                this.$set(
                    this.attendanceList.find(
                        (item) => item.o_id == value.attendance_record.event.o_id
                    ).attendance[0],
                    "dispute_record",
                    value
                );
            }
        },
        currentTerm() {
            this.pullEventsByType();
        },
        eventTypes() {
            this.pullEventsByType();
        },
        attendanceList: {
            handler(val) {
                this.$set(
                    this,
                    "attendancePercentage",
                    this.calculateAttendancePercentage(val)
                );
            },
            deep: true
        }
    },
    computed: {
        ...mapFields([
            "user",
            "users",
            "terms",
            "currentTerm",
            "eventTypes",
            "attendanceTypes"
        ])
    },
    mounted() {
        if (this.terms == null) this.$store.dispatch("pullTerms");
        if (this.eventTypes == null) this.$store.dispatch("pullEventTypes");
        if (this.attendanceTypes == null)
            this.$store.dispatch("pullAttendanceTypes");
        if (this.terms != null && this.eventTypes != null) {
            this.pullEventsByType();
        }
    },
    methods: {
        pullEventsByType() {
            if (this.currentTerm != null) {
                this.getAttendance();
            }
        },

        perColor(total) {
            if (total < 80) {
                return "#E96B81";
            } else if (total >= 90) {
                return "#409EFF";
            }
            return "#F3B861";
        },

        calculateAttendancePercentage(attendanceList) {
            if (attendanceList == null || attendanceList.length == 0) return 0;
            var total = attendanceList.length;
            var count = 0;
            attendanceList.forEach((event) => {
                if (event.attendance.length != 0) {
                    if (
                        event.attendance[0].attendance_type.short == "AC" ||
            event.attendance[0].attendance_type.short == "E" ||
            event.attendance[0].attendance_type.short == "X"
                    )
                        count++;
                }
            });

            return Math.round(100 * (count / total));
        },
        getAttendance() {
            this.axios
                .get("/api/v1/attendance/self", {
                    params: {
                        event_type: this.eventTypeId,
                        terms: [this.currentTerm]
                    },
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.$set(this, "attendanceList", response.data);
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors,
                        type: "error"
                    });
                });
        },

        newDispute(event) {
            this.finalize = false;
            this.approve = false;
            this.creating = true;
            this.$set(this, "tempDispute", {
                type: null,
                event: event,
                message: null,
                file: false
            });
            this.$refs.disputeModal.open();
        },

        disputeColor(dispute) {
            if (dispute == null) {
                return " ";
            }
            if (dispute.is_redisputable) {
                return "warning";
            } else if (dispute.is_approved == 1) {
                return "success";
            } else if (dispute.is_approved == 0) {
                return "danger";
            } else if (dispute.is_finalized) {
                return "info";
            }
            return "info";
        },
        disputeStatus(dispute) {
            if (dispute == null) {
                return "Dispute";
            }
            if (dispute.is_redisputable) {
                return "Redispute";
            } else if (dispute.is_approved == 1) {
                return "Approved";
            } else if (dispute.is_approved == 0) {
                return "Denied";
            } else if (dispute.is_finalized) {
                return "Under Review";
            }
            return "Submitted";
        },
        showDispute(event, viewOnly = false) {
            var attendance = event.attendance[0]
            var dispute = attendance.active_dispute_record
            if (dispute == null && attendance.dispute_records.length > 0) {
                dispute = attendance.dispute_records[0]
            }
            if (dispute == null || (dispute.is_redisputable && !viewOnly)) {
                this.newDispute(event);
                return;
            }
            this.tempDispute = dispute;
            this.finalize = false;
            this.approve = false;
            this.creating = false;
            this.$refs.disputeModal.open();
        },

        cCellStyle(row) {
            if (row.column.label == "Total") {
                if (row.row.total) {
                    if (row.row.total < 80) {
                        return "background-color:rgba(234, 108, 130, 0.6);";
                    } else if (row.row.total < 90) {
                        return "background-color:rgba(243, 184, 97, 0.6);";
                    }
                    return "background-color:rgba(104, 158, 241, 0.6);";
                }
            }
        },

        cAttendanceColor(type) {
            if (type == "AC" || type == "E" || type == "X") {
                return "color: #599EF8;";
            } else if (type == "P") {
                return "";
            }
            return "color: red;";
        }
    }
};
</script>
